// extracted by mini-css-extract-plugin
module.exports = {"markdownNote":"style_markdownNote__19KKy","markdownDescriptionContainer":"style_markdownDescriptionContainer__DXs8I"};